import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/products/[id]/ProductDetailPageClient.js");
